import { LOGIN_FAILURE, LOGIN_SUCCESS, LOGOUT_SUCCESS } from "./auth.actions";

const initialState = {
  token: null,
  error: null,
};

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN_SUCCESS:
      return {
        ...state,
        token: action.payload.token,
        expiry: action.payload.expiry,
        error: null,
      };
    case LOGIN_FAILURE:
      return {
        ...state,
        token: null,
        expiry: null,
        error: action.payload,
      };
    case LOGOUT_SUCCESS:
      return {
        ...state,
        token: null,
        expiry: null,
        error: null,
      };
    default:
      return state;
  }
};

export default authReducer;
